import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import { fetchSalesInvoices } from '../../actions/salesInvoice_actions.jsx';
import { setDefaultDays } from '../../actions/purchaseOrders_actions';
import SIPaymentList from '../../components/AR/SIPaymentList/SIPaymentList';
import { fetchBaseUsers } from '../../actions/settings_actions';

const SIPaymentListContainer = reduxForm({
  form: 'SIPaymentList',
})(SIPaymentList);

const selector = formValueSelector('SIPaymentList');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const Seller = selector(state, 'Seller');
  return {
    Days,
    FromDate,
    ToDate,
    Seller,
    users: state.settings.all,
    salesInvoice: state.salesInvoice.all,
    isLoading: state.salesInvoice.isLoading,
    error: state.salesInvoice.error,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, {
  fetchSalesInvoices,
  fetchBaseUsers,
  setDefaultDays,
})(SIPaymentListContainer);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/SIPaymentList.jsx